var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialSymbolsLightDeleteOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.34616 16.6666C5.97394 16.6666 5.65644 16.5355 5.39366 16.2732C5.13144 16.011 5.00033 15.6935 5.00033 15.3207V4.9999H4.16699V4.16657H7.50033V3.5249H12.5003V4.16657H15.8337V4.9999H15.0003V15.3207C15.0003 15.7041 14.872 16.0241 14.6153 16.2807C14.3581 16.538 14.0378 16.6666 13.6545 16.6666H6.34616ZM14.167 4.9999H5.83366V15.3207C5.83366 15.4702 5.88171 15.593 5.97783 15.6891C6.07394 15.7852 6.19671 15.8332 6.34616 15.8332H13.6545C13.7823 15.8332 13.8998 15.7799 14.007 15.6732C14.1137 15.566 14.167 15.4485 14.167 15.3207V4.9999ZM8.17366 14.1666H9.00699V6.66657H8.17366V14.1666ZM10.9937 14.1666H11.827V6.66657H10.9937V14.1666Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsLightDeleteOutline);
export default __webpack_public_path__ + "static/media/material-symbols-light_delete-outline.2d88725d5a0b95e8a6a2419bcdc74450.svg";
export { ForwardRef as ReactComponent };